<div id="pin-reset-success" class="d-flex flex-column justify-content-start">
  <div class="tux-bg-success p-3" style="color: #fff" tabindex="-1" id="successTxt">
    <span class="fa fa-check-circle"></span> Success!
  </div>
  <div class="container" style="padding: 30px 50px;">
    <h1 class="tux_lead" style="color: #333">Your PIN has been reset!</h1>
  </div>
</div>
